// extracted by mini-css-extract-plugin
module.exports = {"uniBlue":"#00adef","accordion":"accordion-module--accordion--3TXOL"};